import { configureStore } from '@reduxjs/toolkit';

import authReducer from './auth/authSlice';
import menuReducer from './menu/menuSlice';
import settingsReducer from './settings/settingsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    menu: menuReducer,
    settings: settingsReducer,
  },
});
